import { render, staticRenderFns } from "./TopBarActions.vue?vue&type=template&id=c8f12b46&scoped=true"
import script from "./TopBarActions.vue?vue&type=script&lang=js"
export * from "./TopBarActions.vue?vue&type=script&lang=js"
import style0 from "./TopBarActions.vue?vue&type=style&index=0&id=c8f12b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f12b46",
  null
  
)

export default component.exports